import React, { forwardRef } from "react"
import styled from "styled-components"

const StyledGridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(16, 1fr);
	position: relative;
	//width: 100%;

	${[...new Array(16)].map((item, index) => {
		return `
            &.grid-${index + 1} {
                grid-template-columns: repeat(${index + 1}, 1fr);
            }
        `
	})}
	&.no-margin {
		margin-left: 0;
		margin-right: 0;
	}

	&.no-margin-l {
		margin-left: 0;
	}

	&.no-margin-r {
		margin-right: 0;
	}

	&.padding {
		padding-left: var(--grid-margin-l);
		padding-right: var(--grid-margin-r);
	}

	&.padding-l {
		padding-left: var(--grid-margin-l);
	}

	&.padding-r {
		padding-right: var(--grid-margin-r);
	}

	&.no-gap {
		grid-gap: 0;
	}

	&.full-width {
		width: 100%;
	}

	.grid-item {
		aspect-ratio: 1;
		border-bottom: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
		border-right: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
	}
`

const GridContainerRectangles = forwardRef(function GridContainerRectangles({ style, className = "", children, ...props }, ref) {
	return (
		<StyledGridContainer ref={ref} style={style} className={`grid-container ${className}`} {...props}>
			{children}
		</StyledGridContainer>
	)
})

export default GridContainerRectangles
